<template>
  <div class="tebodyitem">
    <div class="tebodyitem-header"><span>配置内容</span></div>
  </div>
  <div class="tebodyitem">
    <el-form-item label="获取费用项" required>
      <el-select v-model="fretrieveCostItems" placeholder="请选择" clearable multiple collapse-tags>
        <el-option v-for="(item, idx) in retrieveCostItems" :label="item.fieldName" :value="item.fieldName" :key="idx" />
      </el-select>
    </el-form-item>
  </div>
  <div class="tebodyitem full">
    <el-form-item label="计总费用项" required>
      <div style="background-color: #F8F9FA; border-radius: 4px; padding: 12px; box-sizing: border-box; width: 100%;">
        <el-input v-model="filterChargeKeyword" placeholder="请输入费用名称" :suffix-icon="Search" />
        <el-tree
          ref="chargeItemsIns"
          v-if="chargeItemVOS?.length > 0"
          style="background-color: #FFFFFF; margin-top: 4px; max-height: 278px; overflow: auto;"
          :data="chargeItemVOS"
          :show-checkbox="true"
          :props="{ children: 'children', label: 'fieldDesc' }"
          node-key="fieldName"
          :default-checked-keys="fchargeItemVOS"
          @check="chargeItemsCheckHandle"
          :filter-node-method="(value, data) => {
            console.log('value, data', value, data);
            if (!value) return true
            return  data.fieldDesc.toUpperCase().includes(value.toUpperCase());
          }"
        />
      </div>
    </el-form-item>
  </div>
  <div class="tebodyitem">
    <el-form-item label="官方报价单接收邮箱账号">
      <el-input v-model="form.emailAddress" clearable placeholder="请输入" />
    </el-form-item>
    <!-- HPL 查价模板：是否获报价单（按内容收缩，与邮箱保持舒适间距） -->
    <el-form-item label="是否获报价单" v-if="carrier == 'HPL'" style="flex: 0 0 auto; margin-left: 24px;">
      <el-switch v-model="form.needQuotation" />
    </el-form-item>
  </div>
  <MoreSetting>
    <div class="tebodyitem">
      <el-form-item label="币种币值拆分项">
        <el-select v-model="form.currencySplitFields" placeholder="请选择" clearable multiple collapse-tags>
          <el-option v-for="(item, idx) in currencySplitFields" :label="item?.fieldName" :value="item?.fieldName" :key="idx" />
        </el-select>
      </el-form-item>
      <template v-if="[ CONST.APP_CODE_QUERY_PRICE_QQ_QQS ].includes(appCode)">
      <el-form-item label="SHEET页汇总依据">
        <el-select v-model="form.sheetTotalFiled" placeholder="请选择" clearable collapse-tags>
          <el-option v-for="(item, idx) in sheetTotalFields" :label="item?.fieldDesc" :value="item?.fieldName" :key="idx" />
        </el-select>
      </el-form-item>
      </template>
      <template v-if="[ CONST.APP_CODE_QUERY_PRICE_QQ ].includes(appCode)">
      <el-form-item label="Excel展示结构">
        <el-select v-model="form.displayStructure" placeholder="请选择" @change="displayStructureChangeHandle">
          <el-option v-for="item in displayStructureOptions" :label="item?.label" :value="item?.value" :key="item.value" />
        </el-select>
      </el-form-item>
    </template>
    </div>
    <div class="tebodyitem" v-if="[ CONST.APP_CODE_QUERY_PRICE_QQ_QQS ].includes(appCode)">
      <el-form-item label="获取价格类型">
        <el-select v-model="form.priceTypeFields" placeholder="请选择" clearable multiple collapse-tags>
          <el-option v-for="(item, idx) in priceTypeFields" :label="item?.fieldName" :value="item?.fieldName" :key="idx" />
        </el-select>
      </el-form-item>
      <el-form-item class="mock-formitem" v-if="form.priceTypeFields?.length == 2">
        <el-checkbox v-model="form.mergeSheet" />
        <div class="mock-formitem-checkbox-label">
          <span>合并展示在同一个Sheet页面</span>
          <el-popover
            placement="top"
            :width="180"
            trigger="hover"
            content="取消勾选则分开展示在2个Sheet页"
          >
            <template #reference>
              <el-icon><Warning /></el-icon>
            </template>
          </el-popover>
        </div>
      </el-form-item>
    </div>
  </MoreSetting>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import { Close, Search, Minus, ArrowDown, CirclePlus, Warning, CirclePlusFilled } from '@element-plus/icons-vue'
  import MoreSetting from '../moresetting/index';
  import * as CONST from '@/assets/const'

  const emits = defineEmits([ 'change' ])

  const props = defineProps({
    carrier: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: null
    },
    appCode: {
      type: String,
      default: ''
    }
  })

  const displayStructureOptions = ref([
    { value: 'route_pol_pod', label: '航线 >起运港 >目的港', sheetTotalFiled_relation: 'route' },
    { value: 'route_pod_pol', label: '航线 > 目的港 > 起运港', sheetTotalFiled_relation: 'route'  },
    { value: 'pol_route_pod', label: '起运港 > 航线 > 目的港', sheetTotalFiled_relation: 'pol_code'  },
  ])

  const defaultDisplayStructure = 'route_pol_pod'

  const form = ref({
    mergeSheet: true,
    displayStructure: defaultDisplayStructure,
    // QQ 类型默认获取报价单，QQS 类型默认不获取
    needQuotation: props.appCode == CONST.APP_CODE_QUERY_PRICE_QQ
  })
  watch(() => form.value, () => {
    emits('change', form.value)
  }, { deep: true });

  const retrieveCostItems = ref([]);
  const fretrieveCostItems = ref([]);
  watch(() => fretrieveCostItems.value, () => {
    form.value.retrieveCostItems = fretrieveCostItems.value.map(fieldName => ({ fieldName }));
  });

  const chargeItemVOS = ref([]);
  const fchargeItemVOS = ref([]);
  const currencySplitFields = ref([]);
  const sheetTotalFields = ref([]);
  const priceTypeFields = ref([]);
  const init = () => {
    // 获取费用项
    retrieveCostItems.value = []
    chargeItemVOS.value = []
    fretrieveCostItems.value = []
    props.data?.retrieveCostItems.map(item => {
      retrieveCostItems.value.push(item);
      if(item.checked == 2) {
        fretrieveCostItems.value.push(item.fieldName);
      }
    });
    form.value.retrieveCostItems = fretrieveCostItems.value.map(fieldName => ({ fieldName }))

    // 计总费用项
    props.data?.chargeItemVOS.forEach(item => {
      // 子项集和
      const children = [];

      item.chargeItems.forEach(_item => {
        // 获取子项，设置子项信息和父项pfieldName
        children.push({ pfieldName: item?.chargeType?.fieldName, ..._item });

        if(_item.checked == 2) {
          // 设置子项默认选中数组
          fchargeItemVOS.value.push(_item.fieldName);
        }
      });

      chargeItemVOS.value.push({ ...item?.chargeType, children });

      form.value.chargeItemVOS = form.value.chargeItemVOS || []
      form.value.chargeItemVOS.push({
        chargeType: item?.chargeType,
        chargeItems: children
      })
    });

    // 官方报价单接收邮箱账号
    form.value.emailAddress = props.data?.emailAddress;

    // 是否获报价单（QQ 默认 true，QQS 默认 false）
    form.value.needQuotation = props.data?.needQuotation ?? (props.appCode == CONST.APP_CODE_QUERY_PRICE_QQ);

    // 币种币值拆分项
    currencySplitFields.value = []
    form.value.currencySplitFields = []
    props.data?.currencySplitFields.map(item => {
      currencySplitFields.value.push(item);
      if(item.checked == 2) {
        form.value.currencySplitFields.push(item.fieldName);
      }
    });
    // sheet页汇总依据
    sheetTotalFields.value = []
    form.value.sheetTotalFields = []
    props.data?.sheetTotalFields.map(item => {
      sheetTotalFields.value.push(item);
      if(item.checked == 2) {
        form.value.sheetTotalFiled = item.fieldName;
      }
    });

    if(props.appCode == CONST.APP_CODE_QUERY_PRICE_QQ) {
      const displayStructureFields = props.data?.displayStructureFields || [];
      const displayStructure = (displayStructureFields.find(item => item.checked == 2) || {}).fieldName || defaultDisplayStructure;
      form.value.displayStructure = displayStructure
    }

    // 获取价格类型
    priceTypeFields.value = [];
    form.value.priceTypeFields = []
    props.data?.priceTypeFields.map(item => {
      priceTypeFields.value.push(item);
      if(item.checked == 2) {
        form.value.priceTypeFields.push(item.fieldName);
      }
    });
  }
  watch(() => props.data, () => {
    init();
  }, { deep: true });

  const chargeItemsCheckHandle = (target, res) => {
    const _chargeItemVOS = []
    const map = {}
    res.checkedNodes.forEach(ritem => {
      ritem.checked = 2
      if(ritem.pfieldName) map[ritem.pfieldName] = map[ritem.pfieldName] || []
      if(!ritem?.children && map[ritem.pfieldName]) {
        map[ritem.pfieldName].push(ritem)
      }
    })

    Object.keys(map).forEach(gfn => {
      // 获取父项的子项长度
      const length = getCheckedChildLength(gfn)
      _chargeItemVOS.push({
        chargeType: { fieldName: gfn, check: map[gfn].length === length ? 2 : 3 },
        chargeItems: map[gfn]
      })
    })
    form.value.chargeItemVOS = _chargeItemVOS;
  }

  const getCheckedChildLength = (fieldName) => {
    // 获取父项的子项长度
    let res = 0
    const target = chargeItemVOS.value.find(i => i.fieldName === fieldName) || {}
    res = (target.children || []).length
    return res
  }

  // 快速筛选
  const filterChargeKeyword = ref('');
  const chargeItemsIns = ref(null);
  watch(filterChargeKeyword, (val) => {
    chargeItemsIns.value.filter(val)
  })

  const displayStructureChangeHandle = (val) => {
    // 通过选中的值找到对应的选项对象
    const selectedOption = displayStructureOptions.value.find(option => option.value === val);
    if (selectedOption) {
      form.value.sheetTotalFiled = selectedOption.sheetTotalFiled_relation;
    }
  }
</script>

<style scoped lang="less">
  @import "./index.less";
</style>